export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1573384293689-0327bf65bd86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxhcmNoaXRlY3R1cmUlMjBuaWdodHxlbnwwfHx8fDE3ODk4Mzg4OTh8MA&ixlib=rb-4.1.0&q=85&w=1920",
  intro: "https://images.unsplash.com/photo-1579724175242-0204ecac28cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxjb25jcmV0ZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODk4Mzg4ODB8MA&ixlib=rb-4.1.0&q=85&w=1280",
  leadership: "https://images.unsplash.com/photo-1569258592171-357ea26da4df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxjb25jcmV0ZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODk4Mzg4ODB8MA&ixlib=rb-4.1.0&q=85&w=1280",
  project1: "https://images.pexels.com/photos/3882638/pexels-photo-3882638.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  project2: "https://images.pexels.com/photos/11831530/pexels-photo-11831530.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  project3: "https://images.unsplash.com/photo-1565626424178-c699f6601afd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxjb25jcmV0ZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODk4Mzg4ODB8MA&ixlib=rb-4.1.0&q=85&w=940",
  project4: "https://images.pexels.com/photos/4328661/pexels-photo-4328661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  project5: "https://images.unsplash.com/photo-1565043534426-8a67ac8671e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxhcmNoaXRlY3R1cmUlMjBuaWdodHxlbnwwfHx8fDE3ODk4Mzg4OTh8MA&ixlib=rb-4.1.0&q=85&w=940",
  project6: "https://images.pexels.com/photos/27230467/pexels-photo-27230467.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
  {
    num: "01",
    id: "building-development",
    title: "Building Development",
    short: "Professional building development services supporting projects from preparation through construction and completion.",
    long: "We deliver end-to-end building development services, coordinating design, planning, and construction phases with a focus on practical execution and clear client communication. From site preparation through structural work to final handover, our approach is grounded in careful planning and attention to detail.",
    icon: "layers",
  },
  {
    num: "02",
    id: "commercial-construction",
    title: "Commercial Construction",
    short: "Construction services for commercial buildings and business premises.",
    long: "Commercial construction projects require a structured approach and reliable delivery. We work with clients on offices, retail units, mixed-use developments and business premises, focusing on quality workmanship and adherence to schedule.",
    icon: "building",
  },
  {
    num: "03",
    id: "domestic-construction",
    title: "Domestic Construction",
    short: "Construction services for residential and domestic building projects.",
    long: "From new-build homes to residential extensions and renovations, our domestic construction service centres on understanding how a home should function for its occupants — delivered with care, transparency and craft.",
    icon: "home",
  },
  {
    num: "04",
    id: "specialised-construction",
    title: "Specialised Construction",
    short: "Specialised construction activities tailored to specific project requirements.",
    long: "Some projects call for specialised construction expertise — structural interventions, heritage sensitive work, complex façades or bespoke technical builds. We tailor our approach to the demands of each brief.",
    icon: "ruler",
  },
];

export const APPROACH = [
  { num: "01", title: "Understand", desc: "We begin by understanding the project’s requirements, objectives and expectations." },
  { num: "02", title: "Plan", desc: "We establish a practical approach based on the scope and requirements of the project." },
  { num: "03", title: "Construct", desc: "Construction work is carried out with attention to quality, safety and detail." },
  { num: "04", title: "Complete", desc: "The project progresses toward professional completion and handover." },
];

export const PRINCIPLES = [
  { num: "01", title: "Quality", desc: "Attention to workmanship and project requirements." },
  { num: "02", title: "Communication", desc: "Clear communication throughout the construction process." },
  { num: "03", title: "Professionalism", desc: "A structured and practical approach to project delivery." },
  { num: "04", title: "Attention to Detail", desc: "Careful consideration of construction details and client requirements." },
];

export const PROJECTS = [
  { id: 1, title: "Riverside Residential", type: "Domestic Construction", year: "2025", location: "London", img: "project1" },
  { id: 2, title: "Thanet Office Building", type: "Commercial Construction", year: "2024", location: "Croydon", img: "project2" },
  { id: 3, title: "Concrete Studio Extension", type: "Building Development", year: "2024", location: "Kent", img: "project3" },
  { id: 4, title: "Structural Refurbishment", type: "Specialised Construction", year: "2023", location: "Surrey", img: "project4" },
  { id: 5, title: "Mixed-Use Development", type: "Commercial Construction", year: "2023", location: "London", img: "project5" },
  { id: 6, title: "Brick & Glass Facade", type: "Building Development", year: "2022", location: "Manchester", img: "project6" },
];
